export const candidateConstants = {
  // create candidate data
  CREATE_CANDIDATE_ACTION_REQUEST: "CREATE_CANDIDATE_ACTION_REQUEST",
  CREATE_CANDIDATE_ACTION_SUCCESS: "CREATE_CANDIDATE_ACTION_SUCCESS",
  CREATE_CANDIDATE_ACTION_FAILURE: "CREATE_CANDIDATE_ACTION_FAILURE",

  // create candidate data
  UPDATE_CANDIDATE_PROFILE_ACTION_REQUEST:
    "UPDATE_CANDIDATE_PROFILE_ACTION_REQUEST",
  UPDATE_CANDIDATE_PROFILE_ACTION_SUCCESS:
    "UPDATE_CANDIDATE_PROFILE_ACTION_SUCCESS",
  UPDATE_CANDIDATE_PROFILE_ACTION_FAILURE:
    "UPDATE_CANDIDATE_PROFILE_ACTION_FAILURE",

  //candidate profile
  GET_CANDIDATE_PROFILE_DATA_ACTION_REQUEST:
    "GET_CANDIDATE_PROFILE_DATA_ACTION_REQUEST",
  GET_CANDIDATE_PROFILE_DATA_ACTION_SUCCESS:
    "GET_CANDIDATE_PROFILE_DATA_ACTION_SUCCESS",
  GET_CANDIDATE_PROFILE_DATA_ACTION_FAILURE:
    "GET_CANDIDATE_PROFILE_DATA_ACTION_FAILURE",

  // candidate intro
  GET_CANDIDATE_INTRO_DATA_ACTION_REQUEST:
    "GET_CANDIDATE_INTRO_DATA_ACTION_REQUEST",
  GET_CANDIDATE_INTRO_DATA_ACTION_SUCCESS:
    "GET_CANDIDATE_INTRO_DATA_ACTION_SUCCESS",
  GET_CANDIDATE_INTRO_DATA_ACTION_FAILURE:
    "GET_CANDIDATE_INTRO_DATA_ACTION_FAILURE",

  // candidate EducationAL
  GET_CANDIDATE_ALL_EDUCATIONAL_DATA_ACTION_REQUEST:
    "GET_CANDIDATE_ALL_EDUCATIONAL_DATA_ACTION_REQUEST",
  GET_CANDIDATE_ALL_EDUCATIONAL_DATA_ACTION_SUCCESS:
    "GET_CANDIDATE_ALL_EDUCATIONAL_DATA_ACTION_SUCCESS",
  GET_CANDIDATE_ALL_EDUCATIONAL_DATA_ACTION_FAILURE:
    "GET_CANDIDATE_ALL_EDUCATIONAL_DATA_ACTION_FAILURE",

  // candidate education by id
  GET_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_REQUEST:
    "GET_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_REQUEST",
  GET_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_SUCCESS:
    "GET_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_SUCCESS",
  GET_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_FAILURE:
    "GET_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_FAILURE",

  // update candidate education by id
  UPDATE_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_REQUEST:
    "UPDATE_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_REQUEST",
  UPDATE_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_SUCCESS:
    "UPDATE_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_SUCCESS",
  UPDATE_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_FAILURE:
    "UPDATE_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_FAILURE",

  // update candidate education by id
  CREATE_CANDIDATE_EDUCATION_DATA_ACTION_REQUEST:
    "CREATE_CANDIDATE_EDUCATION_DATA_ACTION_REQUEST",
  CREATE_CANDIDATE_EDUCATION_DATA_ACTION_SUCCESS:
    "CREATE_CANDIDATE_EDUCATION_DATA_ACTION_SUCCESS",
  CREATE_CANDIDATE_EDUCATION_DATA_ACTION_FAILURE:
    "CREATE_CANDIDATE_EDUCATION_DATA_ACTION_FAILURE",

  // candidate profession
  GET_CANDIDATE_ALL_PROFESSIONAL_DATA_ACTION_REQUEST:
    "GET_CANDIDATE_ALL_PROFESSIONAL_DATA_ACTION_REQUEST",
  GET_CANDIDATE_ALL_PROFESSIONAL_DATA_ACTION_SUCCESS:
    "GET_CANDIDATE_ALL_PROFESSIONAL_DATA_ACTION_SUCCESS",
  GET_CANDIDATE_ALL_PROFESSIONAL_DATA_ACTION_FAILURE:
    "GET_CANDIDATE_ALL_PROFESSIONAL_DATA_ACTION_FAILURE",

  // candidate experience by id
  GET_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_REQUEST:
    "GET_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_REQUEST",
  GET_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_SUCCESS:
    "GET_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_SUCCESS",
  GET_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_FAILURE:
    "GET_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_FAILURE",

  ///update candidate experience by id
  UPDATE_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_REQUEST:
    "UPDATE_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_REQUEST",
  UPDATE_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_SUCCESS:
    "UPDATE_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_SUCCESS",
  UPDATE_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_FAILURE:
    "UPDATE_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_FAILURE",

  ///CREATE candidate experience by id
  CREATE_CANDIDATE_PROFESSION_DATA_ACTION_REQUEST:
    "CREATE_CANDIDATE_PROFESSION_DATA_ACTION_REQUEST",
  CREATE_CANDIDATE_PROFESSION_DATA_ACTION_SUCCESS:
    "CREATE_CANDIDATE_PROFESSION_DATA_ACTION_SUCCESS",
  CREATE_CANDIDATE_PROFESSION_DATA_ACTION_FAILURE:
    "CREATE_CANDIDATE_PROFESSION_DATA_ACTION_FAILURE",

  // delete candidate education by id
  DELETE_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_REQUEST:
    "DELETE_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_REQUEST",
  DELETE_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_SUCCESS:
    "DELETE_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_SUCCESS",
  DELETE_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_FAILURE:
    "DELETE_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_FAILURE",

  ///delete candidate experience by id
  DELETE_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_REQUEST:
    "DELETE_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_REQUEST",
  DELETE_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_SUCCESS:
    "DELETE_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_SUCCESS",
  DELETE_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_FAILURE:
    "DELETE_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_FAILURE",
  ///get all candidate skills
  GET_CANDIDATE_ALL_SKILLS_DATA_ACTION_REQUEST:
    "GET_CANDIDATE_ALL_SKILLS_DATA_ACTION_REQUEST",
  GET_CANDIDATE_ALL_SKILLS_DATA_ACTION_SUCCESS:
    "GET_CANDIDATE_ALL_SKILLS_DATA_ACTION_SUCCESS",
  GET_CANDIDATE_ALL_SKILLS_DATA_ACTION_FAILURE:
    "GET_CANDIDATE_ALL_SKILLS_DATA_ACTION_FAILURE",

  // candidate profession
  CREATE_CANDIDATE_SKILLS_DATA_ACTION_REQUEST:
    "CREATE_CANDIDATE_SKILLS_DATA_ACTION_REQUEST",
  CREATE_CANDIDATE_SKILLS_DATA_ACTION_SUCCESS:
    "CREATE_CANDIDATE_SKILLS_DATA_ACTION_SUCCESS",
  CREATE_CANDIDATE_SKILLS_DATA_ACTION_FAILURE:
    "CREATE_CANDIDATE_SKILLS_DATA_ACTION_FAILURE",

  // candidate profession
  DELETE_CANDIDATE_SKILL_BY_ID_DATA_ACTION_REQUEST:
    "DELETE_CANDIDATE_SKILL_BY_ID_DATA_ACTION_REQUEST",
  DELETE_CANDIDATE_SKILL_BY_ID_DATA_ACTION_SUCCESS:
    "DELETE_CANDIDATE_SKILL_BY_ID_DATA_ACTION_SUCCESS",
  DELETE_CANDIDATE_SKILL_BY_ID_DATA_ACTION_FAILURE:
    "DELETE_CANDIDATE_SKILL_BY_ID_DATA_ACTION_FAILURE",

  // candidate profession
  UPDATE_CANDIDATE_SKILL_BY_ID_DATA_ACTION_REQUEST:
    "UPDATE_CANDIDATE_SKILL_BY_ID_DATA_ACTION_REQUEST",
  UPDATE_CANDIDATE_SKILL_BY_ID_DATA_ACTION_SUCCESS:
    "UPDATE_CANDIDATE_SKILL_BY_ID_DATA_ACTION_SUCCESS",
  UPDATE_CANDIDATE_SKILL_BY_ID_DATA_ACTION_FAILURE:
    "UPDATE_CANDIDATE_SKILL_BY_ID_DATA_ACTION_FAILURE",

  // candidate PORTFOLIO
  GET_CANDIDATE_ALL_PORTFOLIO_DATA_ACTION_REQUEST:
    "GET_CANDIDATE_ALL_PORTFOLIO_DATA_ACTION_REQUEST",
  GET_CANDIDATE_ALL_PORTFOLIO_DATA_ACTION_SUCCESS:
    "GET_CANDIDATE_ALL_PORTFOLIO_DATA_ACTION_SUCCESS",
  GET_CANDIDATE_ALL_PORTFOLIO_DATA_ACTION_FAILURE:
    "GET_CANDIDATE_ALL_PORTFOLIO_DATA_ACTION_FAILURE",

  // candidate portfolio by id
  GET_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_REQUEST:
    "GET_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_REQUEST",
  GET_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_SUCCESS:
    "GET_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_SUCCESS",
  GET_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_FAILURE:
    "GET_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_FAILURE",

  ///update candidate portfolio by id
  UPDATE_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_REQUEST:
    "UPDATE_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_REQUEST",
  UPDATE_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_SUCCESS:
    "UPDATE_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_SUCCESS",
  UPDATE_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_FAILURE:
    "UPDATE_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_FAILURE",

  ///CREATE candidate portfolio by id
  CREATE_CANDIDATE_PORTFOLIO_DATA_ACTION_REQUEST:
    "CREATE_CANDIDATE_PORTFOLIO_DATA_ACTION_REQUEST",
  CREATE_CANDIDATE_PORTFOLIO_DATA_ACTION_SUCCESS:
    "CREATE_CANDIDATE_PORTFOLIO_DATA_ACTION_SUCCESS",
  CREATE_CANDIDATE_PORTFOLIO_DATA_ACTION_FAILURE:
    "CREATE_CANDIDATE_PORTFOLIO_DATA_ACTION_FAILURE",

  // delete candidate portfolio by id
  DELETE_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_REQUEST:
    "DELETE_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_REQUEST",
  DELETE_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_SUCCESS:
    "DELETE_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_SUCCESS",
  DELETE_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_FAILURE:
    "DELETE_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_FAILURE",

  // get  candidate invited jobs
  GET_CANDIDATE_INVITED_JOBS_ACTION_REQUEST: "GET_CANDIDATE_INVITED_JOBS_ACTION_REQUEST",
  GET_CANDIDATE_INVITED_JOBS_ACTION_SUCCESS: "GET_CANDIDATE_INVITED_JOBS_ACTION_SUCCESS",
  GET_CANDIDATE_INVITED_JOBS_ACTION_FAILURE: "GET_CANDIDATE_INVITED_JOBS_ACTION_FAILURE",


  GET_CANDIDATE_SUGGESTED_JOBS_ACTION_REQUEST: "GET_CANDIDATE_SUGGESTED_JOBS_ACTION_REQUEST",
  GET_CANDIDATE_SUGGESTED_JOBS_ACTION_SUCCESS: "GET_CANDIDATE_SUGGESTED_JOBS_ACTION_SUCCESS",
  GET_CANDIDATE_SUGGESTED_JOBS_ACTION_FAILURE: "GET_CANDIDATE_SUGGESTED_JOBS_ACTION_FAILURE",

  GET_CANDIDATE_PENDING_TASK_ACTION_REQUEST:
    "GET_CANDIDATE_PENDING_TASK_ACTION_REQUEST",
  GET_CANDIDATE_PENDING_TASK_ACTION_SUCCESS:
    "GET_CANDIDATE_PENDING_TASK_ACTION_SUCCESS",
  GET_CANDIDATE_PENDING_TASK_ACTION_FAILURE:
    "GET_CANDIDATE_PENDING_TASK_ACTION_FAILURE",


    GET_CANDIDATE_INVITED_INTERVIEWS_ACTION_REQUEST: "GET_CANDIDATE_INVITED_INTERVIEWS_ACTION_REQUEST",
    GET_CANDIDATE_INVITED_INTERVIEWS_ACTION_SUCCESS: "GET_CANDIDATE_INVITED_INTERVIEWS_ACTION_SUCCESS",
    GET_CANDIDATE_INVITED_INTERVIEWS_ACTION_FAILURE: "GET_CANDIDATE_INVITED_INTERVIEWS_ACTION_FAILURE",
    
    GET_CANDIDATE_ACCEPTED_INTERVIEWS_ACTION_REQUEST: "GET_CANDIDATE_ACCEPTED_INTERVIEWS_ACTION_REQUEST",
    GET_CANDIDATE_ACCEPTED_INTERVIEWS_ACTION_SUCCESS: "GET_CANDIDATE_ACCEPTED_INTERVIEWS_ACTION_SUCCESS",
    GET_CANDIDATE_ACCEPTED_INTERVIEWS_ACTION_FAILURE: "GET_CANDIDATE_ACCEPTED_INTERVIEWS_ACTION_FAILURE",
};
